import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./http";
import { queryKeys } from "./query";
import type { NotificationItem, Paged } from "./types";

/** Unread notifications for the bell (first page); refreshed every minute and on the `notification.created` live event. */
export function useUnreadNotifications(enabled = true) {
  return useQuery({
    queryKey: queryKeys.notifications(true),
    queryFn: () => api.get<Paged<NotificationItem>>("/api/v1/notifications", { query: { unread: true, page: 1, pageSize: 10 } }),
    enabled,
    refetchInterval: 60_000,
    staleTime: 20_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/api/v1/notifications/${encodeURIComponent(id)}/read`),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.notificationsRoot }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<void>("/api/v1/notifications/read-all"),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.notificationsRoot }),
  });
}
